import { MouseEvent, useCallback } from 'react';

type Props = { value?: string } & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLSpanElement>,
  HTMLSpanElement
>;

export const CodeLabel: React.FC<Props> = ({ className, value, ...props }) => {
  return (
    <span
      className={`${
        className ?? ''
      } font-mono py-1 cursor-copy px-2 bg-gray-1000 rounded-md active:bg-gray-800 transition-colors`}
      {...props}
    />
  );
};
